"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f35 = void 0;
exports.f35 = {
    "#a-s-l": [
        463,
        464
    ]
};
